// src/lib/mapBodyTypes.js
export function mapBodyTypeToShape(bodyType, fuelType) {
  const type = String(bodyType ?? "")
    .toLowerCase()
    .trim();
  const fuel = String(fuelType ?? "")
    .toLowerCase()
    .trim();

  // Electric overrides all
  if (fuel === "electric" || fuel === "electricity") return "ELECTRIC";

  // Canonical mapping (case/space-insensitive)
  const mapping = {
    cabriolet: "CONVERTIBLE",
    convertible: "CONVERTIBLE",

    "medium mpv": "MPV",
    mpv: "MPV",

    coupe: "COUPE",
    estate: "ESTATE",
    wagon: "ESTATE", // common synonym
    hatchback: "HATCHBACK",
    saloon: "SALOON",
    sedan: "SALOON", // US term -> UK term
    suv: "SUV",
    "4x4": "SUV",
    "suv/4x4": "SUV",
    "panel van": "PANEL VAN",
    "high roof panel van": "HIGH ROOF PANEL VAN",
  };

  return mapping[type] || null; // or return "OTHER" if you prefer
}
